/**
 * 编辑回看视频信息
 * Create by liaokai on 2020-06-19 16:08:17
 */
import * as React from 'react';
import {Component} from "react";
import { message, Modal} from "antd";
import {TitleContentTable} from "../../../meeting-list/meeting/menu/lecturer/preview/title-content-table/title-content-table";
import {emailTemplateDestroy} from "../../../../../common/apis/apis/email/emailTemplateDestroy";


interface IProps{
    visible : boolean
    onCancel? : () => void
    onSubmit? : (msg:string) => void
    id : number
}

interface IState{
}

export class EmailTemplateDestroy extends Component<IProps,IState>{
    readonly state : IState = {
    };

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        // if(JSON.stringify(this.props.id) !== JSON.stringify(prevProps.id) ){
        //     this.setState({editItem : this.props.editItem ?? defaultItem})
        // }
    }

    render() {
        let {onCancel,onSubmit,visible,id} = this.props;
        let {} = this.state;
        return (
            <Modal
                visible={visible}
                onCancel={()=>{
                    onCancel?.();
                }}
                onOk={()=>{
                    console.log(this.props)
                    emailTemplateDestroy({id:id}).then(()=>{
                        onSubmit?.('删除成功')
                        onCancel?.()
                    }).catch(e => {
                        message.error("删除失败 " + e.data?.message)
                    })
                }}
                cancelText={"取消"}
                okText={"确认"}
                title={"删除"}
            >
                <TitleContentTable colGap={10} rowGap={10}>
                    <div>您确认删除么？</div>
                </TitleContentTable>
            </Modal>
        );
    }
}
